// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_g5-0";
export var fileCarousel = "_g5-2";
export var removeFileButton = "_g5-1";